import React from 'react'
import { Typography } from '@material-ui/core'
import { Tuning } from './tunings'
import SmartAutocomplete from './SmartAutocomplete'

const TuningsAutocomplete = (props: {
	tunings: Tuning[],
	tuning: Tuning,
	instrument: string
	onTuningChange: (tuning: Tuning) => void,
}) => {

	const {
		tunings,
		tuning,
		instrument,
		onTuningChange
	} = props

	// console.log({ tunings, tuning })

	return (
		<SmartAutocomplete
			keyName='t'
			label='Tuning'
			id='tuning-autocomplete'
			value={tuning}
			options={tunings.filter(tuning => tuning.instrument === instrument)}
			getOptionLabel={(option) => option.name}
			renderOption={(option: any) => (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{option.name}</span>
					<Typography variant='caption' color='textSecondary'>
	          {option.notes.replaceAll(' ', ' • ')}
					</Typography>
        </div>
      )}
			style={{ width: 300, margin: 16 }}
			onChange={(e, tuning) => tuning && onTuningChange(tuning)}
		/>
	)
}

export default TuningsAutocomplete
